jQuery(document).ready(($) => {
  $('.thinkific-accordion').each(function (containerIndex) {
    const $accordionContainer = $(this);
    const expandFirst = $accordionContainer.data('expand-first') === true || $accordionContainer.data('expand-first') === 'true';
    const openLock = $accordionContainer.data('open-lock') === true || $accordionContainer.data('open-lock') === 'true';
    const collapseOthers = $accordionContainer.data('collapse-others') !== false && $accordionContainer.data('collapse-others') !== 'false';

    const $accordionItems = $accordionContainer.find('.thinkific-accordion-item');

    const closeOthers = (currentItem) => {
      $accordionItems.each(function () {
        const $other = $(this);
        if ($other[0] !== currentItem[0]) {
          $other.removeClass('accordion-item-active is-open');
          $other.find('.thinkific-accordion-item-title').attr('aria-expanded', 'false');
          $other.find('.thinkific-accordion-item-icon').text('►');
          $other.find('.thinkific-accordion-item-content').slideUp(300);
        }
      });
    };

    const toggleAccordion = ($item) => {
      const $title = $item.find('.thinkific-accordion-item-title');
      const $content = $item.find('.thinkific-accordion-item-content');
      const $icon = $title.find('.thinkific-accordion-item-icon');
      const isOpen = $item.hasClass('accordion-item-active is-open');

      if (!isOpen) {
        if (collapseOthers) closeOthers($item);

        $item.addClass('accordion-item-active is-open');
        $title.attr('aria-expanded', 'true');
        $icon.text('▼');
        $content.slideDown(300);

        const label = $title.find('.thinkific-question').text().trim();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'accordionOpen',
          click_action: 'clicked accordion',
          click_value: label || 'Accordion Open'
        });
      } else {
        const otherOpenItems = $accordionItems.filter('.accordion-item-active.is-open').not($item);
        const isLastOpen = openLock && otherOpenItems.length === 0;

        if (!isLastOpen) {
          $item.removeClass('accordion-item-active is-open');
          $title.attr('aria-expanded', 'false');
          $icon.text('►');
          $content.slideUp(300);
        }
      }
    };

    $accordionItems.each(function (index) {
      const $item = $(this);
      const $title = $item.find('.thinkific-accordion-item-title');
      const $content = $item.find('.thinkific-accordion-item-content');
      const $icon = $title.find('.thinkific-accordion-item-icon');

      $title.attr({
        'role': 'button',
        'tabindex': '0',
        'aria-expanded': false,
        'aria-controls': `accordion-${containerIndex}-content-${index}`,
      });
      $content.attr({
        'id': `accordion-${containerIndex}-content-${index}`,
        'role': 'region',
      });

      if (index === 0 && expandFirst) {
        $item.addClass('accordion-item-active is-open');
        $title.attr('aria-expanded', 'true');
        $icon.text('▼');
        $content.show();
      } else {
        $item.removeClass('accordion-item-active is-open');
        $title.attr('aria-expanded', 'false');
        $icon.text('►');
        $content.hide();
      }

      $title.on('click', (e) => {
        e.preventDefault();
        toggleAccordion($item);
      });

      $title.on('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          toggleAccordion($item);
        }
      });
    });
  });
});
